<template>
  <button
    :type="type"
    :disabled="disabled"
    class="button"
    :class="{ [priority]: priority, [shape]: shape, 'full-width': fullWidth }"
    @click="onClick"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    name: "Button",
    props: {
      type: {
        type: String,
        default: "button",
        validator: value => ["button", "submit", "reset"].indexOf(value) >= 0
      },
      priority: {
        type: String,
        default: "primary",
        validator: value =>
          ["primary", "secondary", "subtle", "text", "warning"].indexOf(value) >= 0
      },
      shape: {
        type: String,
        default: "square",
        validator: value => ["square", "circle"].indexOf(value) >= 0
      },
      fullWidth: Boolean,
      disabled: Boolean
    },
    methods: {
      onClick() {
        this.$emit("click");
      }
    }
  };
</script>

<style lang="scss">
  button {
    font-family: "Open Sans", Arial, Helvetica, sans-serif;
    color: $color-white;
    background: $color-secondary;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: $font-semibold;
    border-radius: $radius;
    cursor: pointer;
    outline: inherit;
    min-width: 200px;
    box-shadow: 0 2px 18px rgba(0, 0, 0, 0.05);

    &:hover {
      background: $color-primary;
    }

    &:focus {
      box-shadow: 0 2px 12px rgba($color-secondary, 0.4);
    }

    &.secondary {
      border: $border;
      color: $color-secondary;
      background: inherit;

      &:hover {
        border-color: $color-gray-dark;
      }
    }

    &.subtle {
      color: $color-white;
      background: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }

    &.text {
      color: $color-primary;
      background: transparent;
      box-shadow: none;

      &:hover {
        text-decoration: underline;
      }
    }

    &.warning {
      background: $color-red;
      color: $color-white;

      &:hover {
        opacity: 0.9;
      }
    }

    &.circle {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      padding: 15px;
      min-width: 0;
    }

    &:disabled {
      background: #eee;
      color: #999;
      cursor: not-allowed;
    }

    &.full-width {
      display: block;
      width: 100%;
      box-sizing: border-box;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
